import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from "react-router-dom";
import './Navbar.css';

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [isNavbarFixed, setIsNavbarFixed] = useState(false);
  const dropdownRefs = useRef([]);

  const toggleDropdown = (dropdownId) => {
    if (dropdownOpen === dropdownId) {
      setDropdownOpen(null); // Close the dropdown if it's already open
    } else {
      setDropdownOpen(dropdownId); // Otherwise, open the clicked dropdown
    }
  };

  // const toggleDropdown = (dropdownId) => {
  //   setDropdownOpen(dropdownOpen === dropdownId ? null : dropdownId);
  // };

  const handleClickOutside = (event) => {
    if (
      dropdownRefs.current.every(
        (ref) => ref && !ref.contains(event.target)
      ) &&
      dropdownOpen
    ) {
      setDropdownOpen(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      setIsNavbarFixed(scrollPosition > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleDropdownItemClick = () => {
    setDropdownOpen(null); // Close the dropdown

    // Check if the screen width is below a certain breakpoint (e.g., 768px for mobile devices)
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      setNavbarOpen(false); // Close the navbar menu on mobile devices
      const toggler = document.querySelector('.navbar-toggler');
      toggler?.classList.remove('active'); // Remove the 'active' class from the navbar toggler
    }
  };

  const toggleNavbar = () => {
    setNavbarOpen(!navbarOpen);
    const toggler = document.querySelector('.navbar-toggler');
    toggler.classList.toggle('active');
  };



  return (
    <nav className={`navbar ${isNavbarFixed ? 'fixed' : ''}`}>
      <div className="container_nav">
        <div className="navbar-header">

          <button className="navbar-toggler" onClick={toggleNavbar}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          
       

          <li>
            <Link to="/">
              <img src="./images/mylogo.png" alt=""/>
            </Link>
          </li>
        </div>
        <div className={`navbar-menu ${navbarOpen ? 'active' : ''}`}>
          <ul className="navbar-nav">
            <li className="active">
              <NavLink className="nav-link" to="/" exact onClick={handleDropdownItemClick}>
                <i className="far fa-chart-bar"></i>Home
             </NavLink>
            </li>
            <li>
              <NavLink className="nav-link" to="/about" exact onClick={handleDropdownItemClick}>
              <i class="fa-regular fa-address-card"></i>About
             </NavLink>
            </li>
            {/* <li className="navbar-dropdown">
              <NavLink
                to="/services"
                className="dropdown-toggler"
                onClick={() => toggleDropdown('blog')}
              >
                Products <i className="fa fa-angle-down"></i>
              </NavLink>
              <ul
                className={`dropdown ${dropdownOpen === 'blog' ? 'show' : ''}`}
                id="blog"
                ref={(el) => (dropdownRefs.current[1] = el)}
              >
                <li onClick={handleDropdownItemClick}>
                  <NavLink to="/OilFilter">Oil Filter</NavLink>
                </li>
                <li onClick={handleDropdownItemClick}>
                  <NavLink to="/DeselFilter">Diesel Filter</NavLink>
                </li>
                <li onClick={handleDropdownItemClick}>
                  <NavLink to="/FuelStrainer">Fuel Filter</NavLink>
                </li>
                <li onClick={handleDropdownItemClick}>
                  <NavLink to="/InlinepaperOilfilters">Inlinepaper Oil Filter</NavLink>
                </li>
                <li onClick={handleDropdownItemClick}>
                  <NavLink to="/HydraulicFilterSystem">Hydraulic Filter System</NavLink>
                </li>
              </ul>
            </li> */}
            
    <li className="navbar-dropdown">
      <NavLink
        to="/services"
        className="dropdown-toggler"
        onClick={() => toggleDropdown('products')}
      >
        <i class="fab fa-servicestack"></i>Products <i className="fa fa-angle-down"></i>
      </NavLink>
      <ul
        className={`dropdown ${dropdownOpen === 'products' ? 'show' : ''}`}
        id="products"
      >
        <li onClick={handleDropdownItemClick}>
          <NavLink to="/OilFilter">Oil Filter</NavLink>
        </li>
        <li onClick={handleDropdownItemClick}>
          <NavLink to="/DeselFilter">Diesel Filter</NavLink>
        </li>
        <li onClick={handleDropdownItemClick}>
          <NavLink to="/FuelStrainer">Fuel Strainer</NavLink>
        </li>
        <li onClick={handleDropdownItemClick}>
          <NavLink to="/InlinepaperOilfilters">Inline Paper Oil Filter</NavLink>
        </li>
        <li onClick={handleDropdownItemClick}>
          <NavLink to="/HydraulicFilterSystem">Hydraulic Filter System</NavLink>
        </li>
      </ul>
    </li>
            <li>
              <NavLink to="/Testimonial" onClick={handleDropdownItemClick}><i className="far fa-copy"></i>Gallery</NavLink>
            </li>
            <li>
              <NavLink to="/Contact" onClick={handleDropdownItemClick}><i class="far fa-id-badge"></i>Contact</NavLink>
            </li>
          </ul>

          <button className='getquotes responsive_getquotes'>
            <span>
              <Link to="/contact" style={{ color: "white" }}>Get a Quote</Link>
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
